module.exports = __webpack_public_path__ + "static/img/page1-main.51fcb557.jpg";